import axios from 'axios'
import { reject } from 'lodash';
// import router from './../../../router'


export const resetSekolah = ({ commit }) => {
    commit("RESET_SEKOLAH")
}

export const getSekolahs = ({ commit }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-sekolahs/" + payload)
            .then((response) => {
                commit('SET_SEKOLAH', response.data);
                commit("SET_OVERLAY", false, { root: true });
                resolve('ok')
            })
            .catch((errors) => {
                // localStorage.removeItem("token"); //remove user token when logout
                // router.push("/login");
                // commit('SET_ERRORS_FORM_GURU', errors.data.errors);
                reject('fail')
            });
    })
}

export const getSekolahnya = ({ commit }, sekolahnya) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-sekolahnya/" + sekolahnya)
            .then((response) => {
                commit('SET_SEKOLAHNYA', response.data);
                commit("SET_OVERLAY", false, { root: true });
                resolve(response.data)
            })
            .catch((errors) => {
                reject('fail')
                    // localStorage.removeItem("token"); //remove user token when logout
                    // router.push("/login");
            });
    })
}

export const getSekolahList = ({ commit }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/sekolah-list/" + payload.sekolah_id + "/" + payload.key)
            .then((response) => {
                commit("SET_OVERLAY", false, { root: true });
                resolve(response.data)
            })
            .catch((errors) => {
                reject('fail')
                    // localStorage.removeItem("token"); //remove user token when logout
                    // router.push("/login");
            });
    })
}

export const getSekolahListAll = ({ commit }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/sekolah-list-all/" + payload.key)
            .then((response) => {
                commit("SET_OVERLAY", false, { root: true });
                resolve(response.data)
            })
            .catch((errors) => {
                reject('fail')
                    // localStorage.removeItem("token"); //remove user token when logout
                    // router.push("/login");
            });
    })
}


export const storeSekolah = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.data.nama;
    return new Promise((resolve, reject) => {
        axios.post("/api/tambah-sekolah", payload.data).then((response) => {
            let notif = {
                msg: nama + " Berhasil ditambahkan~",
                type: "create"
            }
            dispatch("getSekolahs", payload.user_jensek_id).then(() => {
                commit("SET_NOTIF", notif, { root: true });
                let pay = {
                    role: payload.role,
                    user_jensek_id: payload.user_jensek_id
                }
                dispatch("akun/getAkuns", pay, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            commit("SET_OVERLAY", false, { root: true });
            reject(e.response.data.errors);
        });
    })
}

export const updateSekolah = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.data.nama;
    return new Promise((resolve, reject) => {
        axios.put("/api/update-sekolah", payload.data).then((response) => {
            let notif = {
                msg: nama + " Berhasil diupdate~",
                type: "update"
            }
            dispatch("getSekolahs", payload.user_jensek_id).then(() => {
                commit("SET_NOTIF", notif, { root: true });
                let pay = {
                    role: payload.role,
                    user_jensek_id: payload.user_jensek_id
                }
                dispatch("akun/getAkuns", pay, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            commit("SET_OVERLAY", false, { root: true });
            reject(e.response.data.errors);
        });
    })
}

export const deleteSekolah = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.data.nama;
    return new Promise((resolve, reject) => {
        axios.delete("/api/hapus-sekolah/" + payload.data.user_id).then((response) => {
            commit("SET_OVERLAY", false, { root: true });
            let notif = {
                msg: nama + " Berhasil dihapus~",
                type: "delete"
            }
            dispatch("getSekolahs", payload.user_jensek_id).then(() => {
                commit("SET_NOTIF", notif, { root: true });
                let pay = {
                    role: payload.role,
                    user_jensek_id: payload.user_jensek_id
                }
                dispatch("akun/getAkuns", pay, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            if (e.response.data.code == 1451) {
                let err = "*Akun sekolah telah digunakan !";
                commit("SET_SQL", err, { root: true });
            }
            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

export const updateProsek = ({ commit, dispatch }, payload) => {
    // console.log(payload)
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios.put("/api/update-" + payload.route + "/" + payload.sekolah_id, { data: payload.data }).then((response) => {
            let notif = {
                msg: payload.label + " Berhasil diupdate~",
                type: "update"
            }
            dispatch("getSekolahnya", payload.user_id).then(() => {
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            commit("SET_OVERLAY", false, { root: true });
            // commit("SET_ERROR_PROSEK", e.response);
            reject(e.response.data.errors)
        });
    })
}

export const updateFileProsek = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let formData = new FormData();
    for (const [key, value] of Object.entries(payload.forms)) {
        formData.append(key, value);
    }

    return new Promise((resolve, reject) => {
        axios.post("/api/update-" + payload.route, formData).then((response) => {
            let notif = {
                msg: payload.label + " Berhasil diupdate~",
                type: "update"
            }
            dispatch("getSekolahnya", payload.forms.user_id).then(() => {
                commit("SET_NOTIF", notif, { root: true });
                resolve(response.data)
            });
        }).catch((e) => {
            commit("SET_OVERLAY", false, { root: true });
            reject(e.response.data.errors)
        });
    })
}

export const storeAlamat = ({ commit, dispatch }, payload) => {
    // console.log(payload)
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios.post("/api/store-alamat", payload.data).then((response) => {
            let notif = {
                msg: "Alamat Berhasil diupdate~",
                type: "update"
            }
            dispatch("getSekolahnya", payload.user_id).then(() => {
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            commit("SET_OVERLAY", false, { root: true });
            reject(e.response.data.errors)
        });
    })
}

// export const updateVimi = ({ commit, dispatch }, payload) => {
//     // console.log(payload)
//     commit("SET_OVERLAY", true, { root: true });
//     return new Promise((resolve, reject) => {
//         axios.put("api/update-vimi/" + payload.sekolah_id, { data: payload.data }).then((response) => {
//             let notif = {
//                 msg: payload.label + " Berhasil diupdate~",
//                 type: "update"
//             }
//             commit("SET_NOTIF", notif, { root: true });
//             dispatch("getSekolahnya", payload.user_id).then(() => {
//                 resolve("ok")
//             });
//         }).catch((e) => {
//             commit("SET_OVERLAY", false, { root: true });
//             reject("fail")
//         });
//     })
// }


export const updateFileSturog = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let formData = new FormData();
    formData.append("file", payload.data);
    formData.append("sekolah_id", payload.sekolah_id);
    formData.append("sekolah_alias", payload.sekolah_alias);

    return new Promise((resolve, reject) => {
        axios.post("/api/update-file-sturog", formData).then((response) => {
            let notif = {
                msg: "Struktur Organisasi Berhasil diupdate~",
                type: "update"
            }
            dispatch("getSekolahnya", payload.user_id).then(() => {
                commit("SET_NOTIF", notif, { root: true });
                resolve(response)
            });
        }).catch((e) => {
            commit("SET_OVERLAY", false, { root: true });
            reject(e.response.data.errors)
        });
    })
}

///////////////////// koordinat